import { render, staticRenderFns } from "./IlluBulb.vue?vue&type=template&id=604a5e6f&"
import script from "./IlluBulb.vue?vue&type=script&lang=js&"
export * from "./IlluBulb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports